import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AttendanceRoutingModule } from './attendance-routing.module';
import { StudentDailyAttendanceComponent } from './student-daily-attendance/student-daily-attendance.component';
import { StudentMonthlyAttendanceComponent } from './student-monthly-attendance/student-monthly-attendance.component';
import { ConsolidatedDailyAttendanceComponent } from './consolidated-daily-attendance/consolidated-daily-attendance.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { AttendanceMonthlyReportComponent } from './attendance-monthly-report/attendance-monthly-report.component';
import { AttendanceSummaryReportComponent } from './attendance-summary-report/attendance-summary-report.component';
import { AttendanceMonthlyReportPrintComponent } from './attendance-monthly-report-print/attendance-monthly-report-print.component';
import { AttendanceSummaryReportPrintComponent } from './attendance-summary-report-print/attendance-summary-report-print.component';
import { MonthlyStudentAttendanceComponent } from './monthly-student-attendance/monthly-student-attendance.component';


@NgModule({
  declarations: [StudentDailyAttendanceComponent, StudentMonthlyAttendanceComponent, ConsolidatedDailyAttendanceComponent, AttendanceMonthlyReportComponent, AttendanceSummaryReportComponent, AttendanceMonthlyReportPrintComponent, AttendanceSummaryReportPrintComponent, MonthlyStudentAttendanceComponent],
  imports: [
    CommonModule,
    AttendanceRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot()
  ]
})
export class AttendanceModule { }
